/**
 * The last durable SSE event id each chat's live stream has folded. A resume
 * sends its chat's cursor as `Last-Event-ID` so the backend replays only the
 * tail. Without a cursor the backend replays the whole turn log, and folding
 * that over content the store already holds doubles the streamed prefix.
 *
 * Every stream owner publishes here, so a stream that takes over from another
 * starts where its predecessor stopped rather than at the beginning.
 * Deliberately session-scoped. A fresh window has no cursor and rebuilds from
 * the full replay instead, which is what the identity seed in
 * `resume-seed.ts` exists to make safe.
 */
const cursors = new Map<string, number>()

export function getResumeCursor(chatId: string): number | undefined {
  return cursors.get(chatId)
}

/** Record the chat's cursor; `undefined` clears it (the turn reached `done`). */
export function setResumeCursor(chatId: string, lastEventId: number | undefined): void {
  if (lastEventId === undefined) cursors.delete(chatId)
  else cursors.set(chatId, lastEventId)
}

/** Follow a temp→real conversation-id rename mid-turn. */
export function migrateResumeCursor(oldChatId: string, newChatId: string): void {
  if (oldChatId === newChatId) return
  const cursor = cursors.get(oldChatId)
  cursors.delete(oldChatId)
  if (cursor !== undefined) cursors.set(newChatId, cursor)
}

export function __resetResumeCursorsForTests(): void {
  cursors.clear()
}
